import classNames from "classnames";
import { ActionIcon } from "PFComponents/action_icon";
import Toggle from "PFComponents/toggle/toggle";
import { TooltipIcon } from "PFComponents/tooltip";
import useStorage from "PFCore/helpers/use_storage";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./smart_suggestions.module.scss";

type SmartSuggestionsShellProps = {
  children: ReactNode;
  empty: boolean;
  style?: React.CSSProperties;
};

export const SmartSuggestionsShell = ({ children, empty, style }: SmartSuggestionsShellProps) => {
  const { t } = useTranslation("search");
  const [isInitiallyVisible, setIsInitiallyVisible] = useStorage<boolean>("smart_suggest_visible", true);
  const [collapsed, setCollapsed] = useState(!isInitiallyVisible);

  return (
    <div className={classNames(css.root, { [css.empty]: empty, [css.collapsed]: collapsed })} style={style}>
      <div className={css.card}>
        <div className={css.content}>
          <div className={css.header}>
            <div className={css.left}>
              <strong className={css.title}>{t("smartSuggestions.title")}</strong>
              <div className={css.toggleWrapper}>
                <Toggle
                  checked={isInitiallyVisible}
                  description={t("smartSuggestions.on")}
                  onChange={() => setIsInitiallyVisible((prev) => !prev)}
                  reversed
                />
                <TooltipIcon content={t("smartSuggestions.toggle")} />
              </div>
            </div>
            <ActionIcon onClick={() => setCollapsed(true)} name="subtract" size="sm" />
          </div>
          <div className={css.children}>{children}</div>
        </div>
      </div>
      <div className={css.collapsedCard}>
        <strong className={css.title}>{t("smartSuggestions.title")}</strong>
        <ActionIcon onClick={() => setCollapsed(false)} name="add" color="paletteNeutral0" size="sm" />
      </div>
    </div>
  );
};
